export * from './lab-result-by-encounters.component';

